import { useQuery } from '@tanstack/react-query';

import { useEpisode } from 'context/episode';
import { useSelectedLocationEpisode } from 'context/locationEpisode';
import { attachmentsQueryKeys, indexAttachments } from 'services/api/attachments';

import { Files } from './filesTab/FilesTab';

const FilesPage = () => {
  const { episode } = useEpisode();
  const { locationEpisode } = useSelectedLocationEpisode();

  const { data: attachmentsCount } = useQuery({
    queryKey: attachmentsQueryKeys.count({ archived: false, locationEpisodeId: locationEpisode?.id }),
    queryFn: ({ signal }) =>
      indexAttachments(
        { archived: false, locationEpisodeId: locationEpisode?.id, pageSize: 1, page: 1, viewOnly: true },
        signal
      ),
    select: (data) => data?.meta.totalRecords,
    enabled: !!locationEpisode?.id,
  });

  return <Files episode={episode} locationEpisode={locationEpisode} initialCount={attachmentsCount} />;
};

export default FilesPage;
